export default function DetailList({ title, details }) {
  return (
    <div className="overflow-hidden bg-white shadow sm:rounded-lg">
      <div className="px-4 py-6 sm:px-6">
        <p className="mt-1 max-w-2xl text-sm leading-6 text-gray-500">{title}</p>
      </div>
      <div className="border-t border-gray-100">
        <dl className="divide-y divide-gray-100">
          {Object.entries(details).map(([k, v]) => {
            return (
              <div key={k} className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-900">{k}</dt>
                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{v}</dd>
              </div>
            );
          })}
        </dl>
      </div>
    </div>
  )

}
